import { ID, IdColor } from "@org-avp/avp-avengers-idmm-service-api";
import { useCallback, useMemo } from "react";
import { idmmApi } from "../apis/idmm-service-api";
import { createCachedLookup } from "../utils/lookup.utils";

export interface IdHelper {
  idData: {
    data?: ID[];
    isLoading: boolean;
    error?: unknown;
  };
  idColorData: {
    data?: IdColor[];
    isLoading: boolean;
    error?: unknown;
  };

  createIdLookup: () => Map<string, ID>;
  createIdColorLookup: () => Map<string, IdColor>;
}

export const useIdHelper = (): IdHelper => {
  const idData = idmmApi.useGetAllIdsQuery();
  const createIdLookup = useCallback(
    () => cacheIdLookup(idData.data),
    [idData.data],
  );
  const idColorData = idmmApi.useGetAllIdColorsQuery();
  const createIdColorLookup = useCallback(
    () => cacheIdColorLookup(idColorData.data),
    [idColorData.data],
  );

  return useMemo(
    () => ({ idData, idColorData, createIdLookup, createIdColorLookup }),
    [createIdColorLookup, createIdLookup, idColorData, idData],
  );
};

const idLookupCache = new WeakMap<ID[], Map<string, ID>>();
const cacheIdLookup = (ids: ID[] | undefined) => {
  return createCachedLookup(
    idLookupCache,
    ids,
    (it) => it,
    (it) => it.idId,
  );
};

const idColorLookupCache = new WeakMap<IdColor[], Map<string, IdColor>>();
const cacheIdColorLookup = (idColors: IdColor[] | undefined) => {
  return createCachedLookup(
    idColorLookupCache,
    idColors,
    (it) => it,
    (it) => it.idColorId,
  );
};
